import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import {
    BannerType,
    BannerView,
    colors
} from "@dotnet/telematics-design-system";

import { body2SemiBoldStyles } from "shared/styles/typography";

import { FileUploadResultProps } from "../../../types";

const FileUploadResult = ({
    successCounter,
    fileNumber,
    fileType,
    companies,
    description
}: FileUploadResultProps) => {
    const { gray300, gray700 } = colors;

    const { t } = useTranslation();

    const errorCheck = successCounter !== fileNumber;
    const companyIds = companies.map(company => company.name);

    const failCounter = fileNumber - successCounter;
    const isSingleCompany = companies.length === 1;

    const singularPluralFail = failCounter === 1 ? "single" : "multiple";
    const singularPluralSuccess = isSingleCompany ? "single" : "multiple";

    const fileEndingTranslation = t(
        `Dialog##file upload##endings##${fileNumber === 1 ? "file" : "files"}`
    );

    return (
        <div>
            <BannerView
                data-testid="file-upload-result-banner"
                bannerType={
                    errorCheck ? BannerType.Warning : BannerType.Success
                }
                title={
                    errorCheck
                        ? t(
                              `Dialog##file upload##fail##${singularPluralFail}`,
                              {
                                  failCount: failCounter,
                                  totalCount: fileNumber,
                                  fileEnding: fileEndingTranslation
                              }
                          )
                        : t(
                              `Dialog##file upload##success##${singularPluralSuccess}`
                          )
                }
                css={css({
                    marginBottom: "16px"
                })}
            />

            <div
                css={css({
                    "> div": {
                        display: "flex",
                        gridTemplateColumns: "auto auto"
                    },

                    "> div:last-of-type": {
                        marginBottom: "16px"
                    },

                    "div > span": {
                        ...body2SemiBoldStyles,
                        margin: "8px 0"
                    },

                    "div > span:first-of-type": {
                        color: gray700,
                        minWidth: "150px"
                    },

                    "& > div:not(:first-of-type)": {
                        borderTop: `1px solid ${gray300}`
                    }
                })}
            >
                <div>
                    <span>{t("Table##file type")} </span>

                    <span>{t(`General##${fileType?.value}`)}</span>
                </div>

                <div>
                    <span>
                        {isSingleCompany
                            ? t("General##company")
                            : t("General##companies")}
                    </span>

                    <span>{companyIds.join(", ")}</span>
                </div>

                <div>
                    <span>{t("Table##description")} </span>
                    <span>{description || "-"}</span>
                </div>
            </div>
        </div>
    );
};
export default FileUploadResult;
